/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveaways_YesInputs */

const id_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

const ms_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

const da_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const de_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const en_us2_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const es_es2_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const es_mx2_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const fil_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oo`)
};

const fr_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const it_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const hu_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igen`)
};

const nl_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const no_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const pl_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak`)
};

const pt_br2_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const ro_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da`)
};

const fi_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä`)
};

const sv_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const vi_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có`)
};

const tr_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet`)
};

const cs_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

const bg_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const ru_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const uk_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Так`)
};

const ar_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم`)
};

const hi_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const th_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช่`)
};

const ja_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const zh_cn2_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const zh_hant1_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const ko_components_giveaways_yes = /** @type {(inputs: Components_Giveaways_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Components_Giveaways_YesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_yes = /** @type {((inputs?: Components_Giveaways_YesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_YesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_yes(inputs)
	if (locale === "ms") return ms_components_giveaways_yes(inputs)
	if (locale === "da") return da_components_giveaways_yes(inputs)
	if (locale === "de") return de_components_giveaways_yes(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_yes(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_yes(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_yes(inputs)
	if (locale === "fil") return fil_components_giveaways_yes(inputs)
	if (locale === "fr") return fr_components_giveaways_yes(inputs)
	if (locale === "it") return it_components_giveaways_yes(inputs)
	if (locale === "hu") return hu_components_giveaways_yes(inputs)
	if (locale === "nl") return nl_components_giveaways_yes(inputs)
	if (locale === "no") return no_components_giveaways_yes(inputs)
	if (locale === "pl") return pl_components_giveaways_yes(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_yes(inputs)
	if (locale === "pt") return pt_components_giveaways_yes(inputs)
	if (locale === "ro") return ro_components_giveaways_yes(inputs)
	if (locale === "fi") return fi_components_giveaways_yes(inputs)
	if (locale === "sv") return sv_components_giveaways_yes(inputs)
	if (locale === "vi") return vi_components_giveaways_yes(inputs)
	if (locale === "tr") return tr_components_giveaways_yes(inputs)
	if (locale === "cs") return cs_components_giveaways_yes(inputs)
	if (locale === "bg") return bg_components_giveaways_yes(inputs)
	if (locale === "ru") return ru_components_giveaways_yes(inputs)
	if (locale === "uk") return uk_components_giveaways_yes(inputs)
	if (locale === "ar") return ar_components_giveaways_yes(inputs)
	if (locale === "hi") return hi_components_giveaways_yes(inputs)
	if (locale === "th") return th_components_giveaways_yes(inputs)
	if (locale === "ja") return ja_components_giveaways_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_yes(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_yes(inputs)
	return ko_components_giveaways_yes(inputs)
});
export { components_giveaways_yes as "components.giveaways.yes" }